import { ChainID } from '@ankr.com/chains-list';

import { ANKR_DOCS_LINKS } from 'modules/common/constants/const';
import { Consensus } from 'modules/chains/components/ChainSelectorsProvider';

const chainIdToDocsChainIdMap: Partial<Record<ChainID, string>> = {
  [ChainID.AVALANCHE]: 'avalanche',
  [ChainID.ARBITRUM]: 'arbitrum',
  [ChainID.BSC]: 'bnb-smart-chain',
  [ChainID.CELO]: 'celo',
  [ChainID.CHILIZ]: 'chiliz',
  [ChainID.ETH]: 'ethereum',
  [ChainID.FANTOM]: 'fantom',
  [ChainID.GNOSIS]: 'gnosis',
  [ChainID.IOTEX]: 'iotex',
  [ChainID.MOONBEAM]: 'moonbeam',
  [ChainID.NEAR]: 'near',
  [ChainID.NERVOS]: 'nervos',
  [ChainID.POLYGON]: 'polygon',
  [ChainID.SYSCOIN]: 'syscoin',
  [ChainID.SOLANA]: 'solana',
  [ChainID.BTTC]: 'bittorrent-chain',
  [ChainID.APTOS]: 'aptos',
  [ChainID.FILECOIN]: 'filecoin',
  [ChainID.HECO]: 'huobi-eco-chain',
  [ChainID.KAIA]: 'kaia',
  [ChainID.KUSAMA]: 'kusama',
  [ChainID.OPTIMISM]: 'optimism',
  [ChainID.POLKADOT]: 'polkadot',
  [ChainID.TRON]: 'tron',
  [ChainID.ZETACHAIN]: 'zetachain',
  [ChainID.ZKSYNC_ERA]: 'zksync-era',
  [ChainID.TENET]: 'tenet',
  [ChainID.SUI]: 'sui',
  [ChainID.SECRET]: 'secret-network',
  [ChainID.SCROLL]: 'scroll',
  [ChainID.ROLLUX]: 'rollux',
  [ChainID.POLYGON_ZKEVM]: 'polygon-zkevm',
  [ChainID.MANTLE]: 'mantle',
  [ChainID.HORIZEN]: 'horizen-eon',
  [ChainID.BASE]: 'base',
  [ChainID.TAIKO]: 'taiko',
  [ChainID.BTC]: 'bitcoin',
  [ChainID.BTC_BLOCKBOOK]: 'bitcoin',
  [ChainID.BTC_MAINNET]: 'bitcoin',
  [ChainID.BTC_SIGNET]: 'bitcoin',
  [ChainID.BTC_BLOCKBOOK_SIGNET]: 'bitcoin',
};

const consensusChainIdToDocsChainIdMap: Partial<Record<ChainID, string>> = {
  [ChainID.ETH]: 'ethereum-beacon',
  [ChainID.GNOSIS]: 'gnosis-beacon',
};

export const getChainDocsLink = (
  chainId: ChainID,
  isConsensusEnabled: boolean,
  consensus?: Consensus,
) => {
  if (chainId === ChainID.MULTICHAIN) {
    return ANKR_DOCS_LINKS.aapiOverview;
  }

  const isBeacon = consensus === 'beacon' && isConsensusEnabled;
  const docsChainID = isBeacon
    ? consensusChainIdToDocsChainIdMap[chainId]
    : chainIdToDocsChainIdMap[chainId];

  return docsChainID
    ? `${ANKR_DOCS_LINKS.chainsList}#${docsChainID}`
    : undefined;
};
